var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _KeyboardKeys_pressedKeys, _KeyboardKeys_pressedThisFrame, _KeyboardKeys_releasedThisFrame;
const disableDefaultKeys = new Set(["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"]);
export class RegularKeys {
    setUp() { }
    resetFrame() { }
    isPressed(keyCode) {
        return false;
    }
    wasPressedThisFrame(keyCode) {
        return false;
    }
    wasReleasedThisFrame(keyCode) {
        return false;
    }
    anyIsPressed(keyCodes) {
        for (const keyCode of keyCodes) {
            if (this.isPressed(keyCode)) {
                return true;
            }
        }
        return false;
    }
    anyWasPressedThisFrame(keyCodes) {
        for (const keyCode of keyCodes) {
            if (this.wasPressedThisFrame(keyCode)) {
                return true;
            }
        }
        return false;
    }
    anyWasReleasedThisFrame(keyCodes) {
        for (const keyCode of keyCodes) {
            if (this.wasReleasedThisFrame(keyCode)) {
                return true;
            }
        }
        return false;
    }
}
export class KeyboardKeys extends RegularKeys {
    constructor() {
        super(...arguments);
        _KeyboardKeys_pressedKeys.set(this, new Set());
        _KeyboardKeys_pressedThisFrame.set(this, new Set());
        _KeyboardKeys_releasedThisFrame.set(this, new Set());
    }
    setUp() {
        // Thought: Should this be adding to a number rather than triggering a boolean? Eh.
        document.addEventListener('keydown', (evt) => {
            if (!__classPrivateFieldGet(this, _KeyboardKeys_pressedKeys, "f").has(evt.code)) {
                __classPrivateFieldGet(this, _KeyboardKeys_pressedThisFrame, "f").add(evt.code);
                // console.log(evt.code);
            }
            __classPrivateFieldGet(this, _KeyboardKeys_pressedKeys, "f").add(evt.code);
            // Also disable scrolling
            if (disableDefaultKeys.has(evt.code)) {
                evt.preventDefault();
            }
        });
        document.addEventListener('keyup', (evt) => {
            __classPrivateFieldGet(this, _KeyboardKeys_pressedKeys, "f").delete(evt.code);
            __classPrivateFieldGet(this, _KeyboardKeys_releasedThisFrame, "f").add(evt.code);
        });
    }
    resetFrame() {
        __classPrivateFieldGet(this, _KeyboardKeys_pressedThisFrame, "f").clear();
        __classPrivateFieldGet(this, _KeyboardKeys_releasedThisFrame, "f").clear();
    }
    isPressed(keyCode) {
        return __classPrivateFieldGet(this, _KeyboardKeys_pressedKeys, "f").has(keyCode);
    }
    wasPressedThisFrame(keyCode) {
        return __classPrivateFieldGet(this, _KeyboardKeys_pressedThisFrame, "f").has(keyCode);
    }
    wasReleasedThisFrame(keyCode) {
        return __classPrivateFieldGet(this, _KeyboardKeys_releasedThisFrame, "f").has(keyCode);
    }
}
_KeyboardKeys_pressedKeys = new WeakMap(), _KeyboardKeys_pressedThisFrame = new WeakMap(), _KeyboardKeys_releasedThisFrame = new WeakMap();
export class ComboKeys extends RegularKeys {
    constructor(...keys) {
        super();
        this.subKeys = keys;
    }
    setUp() {
        this.subKeys.forEach(k => k.setUp());
    }
    resetFrame() {
        this.subKeys.forEach(k => k.resetFrame());
    }
    isPressed(keyCode) {
        return this.subKeys.some(k => k.isPressed(keyCode));
    }
    wasPressedThisFrame(keyCode) {
        return this.subKeys.some(k => k.wasPressedThisFrame(keyCode));
    }
    wasReleasedThisFrame(keyCode) {
        return this.subKeys.some(k => k.wasReleasedThisFrame(keyCode));
    }
}
export const NullKeys = RegularKeys;
